// extracted by mini-css-extract-plugin
export default {"optionCard":"Style_optionCard__-SgqW","skeleton":"Style_skeleton__n09EL","left":"Style_left__7VkYT","goIcon":"Style_goIcon__ReiwN","disabled":"Style_disabled__njd1d"};